import BaseEntity from '../database/BaseEntity.js';

/**
 * Video Entity
 * Represents a Video in the system
 *
 * Built-in fields (auto-generated):
 * - id: Unique identifier
 * - createdAt: Creation timestamp
 * - updatedAt: Last update timestamp
 * - createdBy: Email of user who created the record
 */
class Video extends BaseEntity {
  static collectionName = 'videos';
  static _schema = JSON.parse("{\"name\":\"Video\",\"type\":\"object\",\"properties\":{\"titulo\":{\"type\":\"string\",\"description\":\"Título del video\"},\"descripcion\":{\"type\":\"string\",\"description\":\"Descripción del video\"},\"url_video\":{\"type\":\"string\",\"description\":\"URL del video (YouTube embed, directo, etc.)\"},\"tipo_video\":{\"type\":\"string\",\"enum\":[\"youtube\",\"mp4\",\"iframe\",\"otro\"],\"default\":\"youtube\",\"description\":\"Tipo de video\"},\"thumbnail\":{\"type\":\"string\",\"description\":\"URL de la imagen miniatura del video\"},\"categoria\":{\"type\":\"string\",\"enum\":[\"musica\",\"entretenimiento\",\"noticias\",\"deportes\",\"educacion\",\"otro\"],\"default\":\"musica\",\"description\":\"Categoría del video\"},\"duracion\":{\"type\":\"string\",\"description\":\"Duración del video (ej: 3:45)\"},\"activo\":{\"type\":\"boolean\",\"default\":true,\"description\":\"Si el video está activo\"},\"orden\":{\"type\":\"number\",\"default\":0,\"description\":\"Orden de aparición\"}},\"required\":[\"titulo\",\"url_video\"]}");
}

export { Video };
export default Video;
